export var Kitchen;
(function (Kitchen) {
    Kitchen["BH0"] = "BH000";
    Kitchen["BH1"] = "BH001";
    Kitchen["SA0"] = "SA000";
    Kitchen["SA1"] = "SA001";
    Kitchen["SA2"] = "SA002";
    Kitchen["KW0"] = "KW000";
    Kitchen["KW1"] = "KW001";
    Kitchen["QA0"] = "QA000";
    Kitchen["QA1"] = "QA001";
    Kitchen["AE0"] = "AE000";
    Kitchen["AE1"] = "AE001";
    Kitchen["OM0"] = "OM000";
    Kitchen["OM1"] = "OM001";
    Kitchen["NA0"] = "NA000";
})(Kitchen || (Kitchen = {}));
export var Goal;
(function (Goal) {
    Goal["loseWeight"] = "loseWeight";
    Goal["gainWeight"] = "gainWeight";
    Goal["maintainWeight"] = "maintainWeight";
})(Goal || (Goal = {}));
export var Gender;
(function (Gender) {
    Gender["male"] = "male";
    Gender["female"] = "female";
})(Gender || (Gender = {}));
export var Language;
(function (Language) {
    Language["en"] = "en";
    Language["ar"] = "ar";
})(Language || (Language = {}));
export var Nutrition;
(function (Nutrition) {
    Nutrition["carbs"] = "carbs";
    Nutrition["protein"] = "protein";
    Nutrition["fat"] = "fat";
})(Nutrition || (Nutrition = {}));
export var MacrosPreset;
(function (MacrosPreset) {
    MacrosPreset["recommended"] = "recommended";
    MacrosPreset["highProtein"] = "highProtein";
    MacrosPreset["highFat"] = "highFat";
    MacrosPreset["highCarbs"] = "highCarbs";
    MacrosPreset["evenSplit"] = "evenSplit";
})(MacrosPreset || (MacrosPreset = {}));
export var TicketType;
(function (TicketType) {
    TicketType["UPDATE_LOCATION"] = "UPDATE_LOCATION";
})(TicketType || (TicketType = {}));
export var ActivityLevel;
(function (ActivityLevel) {
    ActivityLevel["level1"] = "level1";
    ActivityLevel["level2"] = "level2";
    ActivityLevel["level3"] = "level3";
    ActivityLevel["level4"] = "level4";
    ActivityLevel["level5"] = "level5";
})(ActivityLevel || (ActivityLevel = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["cash"] = "cash";
    PaymentMethod["cc"] = "cc";
    PaymentMethod["benefit"] = "benefit";
    PaymentMethod["mada"] = "mada";
    PaymentMethod["applePay"] = "applePay";
    PaymentMethod["knet"] = "knet";
})(PaymentMethod || (PaymentMethod = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ongoing"] = "ongoing";
    SubscriptionStatus["paused"] = "paused";
    SubscriptionStatus["cancelled"] = "cancelled";
    SubscriptionStatus["suspended"] = "suspended";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["weekly"] = "weekly";
    SubscriptionFrequency["monthly"] = "monthly";
})(SubscriptionFrequency || (SubscriptionFrequency = {}));
export var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["upcoming"] = "upcoming";
    DeliveryStatus["paymentRequired"] = "paymentRequired";
    DeliveryStatus["paused"] = "paused";
    DeliveryStatus["cancelled"] = "cancelled";
    DeliveryStatus["suspended"] = "suspended";
})(DeliveryStatus || (DeliveryStatus = {}));
export var DDeliveryStatus;
(function (DDeliveryStatus) {
    DDeliveryStatus["delivering"] = "delivering";
    DDeliveryStatus["delivered"] = "delivered";
})(DDeliveryStatus || (DDeliveryStatus = {}));
export var FoodType;
(function (FoodType) {
    FoodType["breakfast"] = "breakfast";
    FoodType["dinner"] = "dinner";
    FoodType["lunch"] = "lunch";
    FoodType["snack"] = "snack";
    FoodType["dessert"] = "dessert";
    FoodType["coffee"] = "coffee";
    FoodType["juice"] = "juice";
})(FoodType || (FoodType = {}));
export var LargestPortionSizeFoodType;
(function (LargestPortionSizeFoodType) {
    LargestPortionSizeFoodType["breakfast"] = "breakfast";
    LargestPortionSizeFoodType["lunch"] = "lunch";
    LargestPortionSizeFoodType["snack"] = "snack";
})(LargestPortionSizeFoodType || (LargestPortionSizeFoodType = {}));
export var PlanType;
(function (PlanType) {
    PlanType["full"] = "full";
    PlanType["custom"] = "custom";
    PlanType["skipBreakfast"] = "skipBreakfast";
    PlanType["skipDinner"] = "skipDinner";
    PlanType["ramadan"] = "ramadan";
    PlanType["businessLunch"] = "businessLunch";
    PlanType["futoor"] = "futoor";
    PlanType["dessert"] = "dessert";
})(PlanType || (PlanType = {}));
export var DietType;
(function (DietType) {
    DietType["balanced"] = "balanced";
    DietType["vegetarian"] = "vegetarian";
    DietType["lowCarb"] = "low-carb";
})(DietType || (DietType = {}));
export var FoodDietType;
(function (FoodDietType) {
    FoodDietType["balanced"] = "balanced";
    FoodDietType["vegetarian"] = "vegetarian";
    FoodDietType["lowCarb"] = "low-carb";
    FoodDietType["gourmet"] = "gourmet";
    FoodDietType["worldCup"] = "world-cup";
    FoodDietType["newMealClub"] = "newMealClub";
})(FoodDietType || (FoodDietType = {}));
export var MacrosType;
(function (MacrosType) {
    MacrosType["recommended"] = "recommended";
    MacrosType["custom"] = "custom";
})(MacrosType || (MacrosType = {}));
export var PortionSize;
(function (PortionSize) {
    PortionSize["tooSmall"] = "tooSmall";
    PortionSize["normal"] = "normal";
    PortionSize["tooBig"] = "tooBig";
})(PortionSize || (PortionSize = {}));
export var Action;
(function (Action) {
    Action["API"] = "API";
    Action["UI_SET"] = "UI_SET";
    Action["AUTH_SET_AUTH"] = "AUTH_SET_AUTH";
    Action["AUTH_SET_VERIFICATION"] = "AUTH_SET_VERIFICATION";
    Action["AUTH_SET_ME"] = "AUTH_SET_ME";
    Action["NEW_SUBSCRIPTION_SET"] = "NEW_SUBSCRIPTION_SET";
    Action["NEW_SUBSCRIPTION_SET_MACROS_DATA"] = "NEW_SUBSCRIPTION_UPDATE_MACROS_DATA";
    Action["FOOD_SET"] = "FOOD_SET";
    Action["FOOD_DAY_SET"] = "FOOD_DAY_SET";
    Action["DELIVERIES_SET"] = "DELIVERIES_SET";
    Action["DELIVERY_SET_MENU"] = "DELIVERY_SET_MENU";
    Action["DELIVERY_SET"] = "DELIVERY_SET";
    Action["DELIVERY_SET_SELECTED"] = "DELIVERY_SET_SELECTED";
    Action["SUBSCRIPTION_SET"] = "SUBSCRIPTION_SET";
    Action["SUBSCRIPTION_UNSET_KEY"] = "SUBSCRIPTION_UNSET_KEY";
    Action["SUBSCRIPTION_SET_CARDS"] = "SUBSCRIPTION_SET_CARDS";
    Action["SUBSCRIPTION_DELETE_CARD"] = "SUBSCRIPTION_DELETE_CARD";
    Action["SUBSCRIPTION_RESET_CARDS"] = "SUBSCRIPTION_RESET_CARDS";
    Action["SUBSCRIPTION_SET_CODES"] = "SUBSCRIPTION_SET_CODES";
    Action["SUBSCRIPTION_INC_AVATAR_VERSION"] = "SUBSCRIPTION_INC_AVATAR_VERSION";
    Action["LOG_LIST_SET"] = "LOGS_SET";
    Action["SUBSCRIPTION_CREATED_EVENT"] = "SUBSCRIPTION_CREATED_EVENT";
    Action["SUBSCRIPTION_PAUSED_EVENT"] = "SUBSCRIPTION_PAUSED_EVENT";
    Action["SUBSCRIPTION_RESUMED_EVENT"] = "SUBSCRIPTION_RESUMED_EVENT";
    Action["SUBSCRIPTION_AUTORENEW_ON_EVENT"] = "SUBSCRIPTION_AUTORENEW_ON_EVENT";
    Action["SUBSCRIPTION_AUTORENEW_OFF_EVENT"] = "SUBSCRIPTION_AUTORENEW_OFF_EVENT";
    Action["SUBSCRIPTION_ADDRESS_CHANGED_EVENT"] = "SUBSCRIPTION_ADDRESS_CHANGED_EVENT";
    Action["SUBSCRIPTION_PLAN_CHANGED_EVENT"] = "SUBSCRIPTION_PLAN_CHANGED_EVENT";
    Action["SUBSCRIPTION_EXTRAS_ADDED_EVENT"] = "SUBSCRIPTION_EXTRAS_ADDED_EVENT";
    Action["SUBSCRIPTION_EXTRAS_REMOVED_EVENT"] = "SUBSCRIPTION_EXTRAS_REMOVED_EVENT";
    Action["DELIVERY_SKIPPED_EVENT"] = "DELIVERY_SKIPPED_EVENT";
    Action["DELIVERY_UNSKIPPED_EVENT"] = "DELIVERY_UNSKIPPED_EVENT";
    Action["DELIVERY_ADDRESS_CHANGED_EVENT"] = "DELIVERY_ADDRESS_CHANGED_EVENT";
    Action["DELIVERY_FOOD_REPLACED_EVENT"] = "DELIVERY_FOOD_REPLACED_EVENT";
    Action["DELIVERY_EXTRAS_ADDED_EVENT"] = "DELIVERY_EXTRAS_ADDED_EVENT";
    Action["DELIVERY_DAY_CHANGED_EVENT"] = "DELIVERY_FOOD_REPLACED_EVENT";
    Action["SIGNED_IN_EVENT"] = "SIGNED_IN_EVENT";
    Action["SIGNED_UP_EVENT"] = "SIGNED_UP_EVENT";
    Action["SIGNED_OUT_EVENT"] = "SIGNED_OUT_EVENT";
    Action["RESET_STATE"] = "RESET_STATE";
    Action["BIOMETRIC_LIST_SET"] = "BIOMETRIC_LIST_SET";
    Action["BIOMETRIC_SET"] = "BIOMETRIC_SET";
    Action["SERVICE_STATUS_SET"] = "SERVICE_STATUS_SET";
    Action["WAITING_LIST_SET"] = "WAITING_LIST_SET";
    Action["WAITING_LIST_RESET"] = "WAITING_LIST_RESET";
    Action["HEALTH_TRACKER_SET_TRACKER"] = "HEALTH_TRACKER_SET_TRACKER";
})(Action || (Action = {}));
export var LogType;
(function (LogType) {
    LogType["DELIVERY_SKIPPED"] = "DELIVERY_SKIPPED";
    LogType["DELIVERY_PLAN_CHANGED"] = "DELIVERY_PLAN_CHANGED";
    LogType["DELIVERY_EXTRAS_ADDED"] = "DELIVERY_EXTRAS_ADDED";
    LogType["DELIVERY_UNSKIPPED"] = "DELIVERY_UNSKIPPED";
    LogType["DELIVERY_ADDRESS_CHANGED"] = "DELIVERY_ADDRESS_CHANGED";
    LogType["DELIVERY_FOOD_REPLACED"] = "DELIVERY_FOOD_REPLACED";
    LogType["DELIVERY_DAY_CHANGED"] = "DELIVERY_DAY_CHANGED";
    LogType["DELIVERY_ADDED"] = "DELIVERY_ADDED";
    LogType["SUBSCRIPTION_PAUSED"] = "SUBSCRIPTION_PAUSED";
    LogType["SUBSCRIPTION_UNPAUSED"] = "SUBSCRIPTION_UNPAUSED";
    LogType["SUBSCRIPTION_ADDRESS_CHANGED"] = "SUBSCRIPTION_ADDRESS_CHANGED";
    LogType["SUBSCRIPTION_PLAN_CHANGED"] = "SUBSCRIPTION_PLAN_CHANGED";
    LogType["SUBSCRIPTION_FREQUENCY_CHANGED"] = "SUBSCRIPTION_FREQUENCY_CHANGED";
    LogType["SUBSCRIPTION_DIET_TYPE_CHANGED"] = "SUBSCRIPTION_DIET_TYPE_CHANGED";
    LogType["SUBSCRIPTION_PLAN_TYPE_CHANED"] = "SUBSCRIPTION_PLAN_TYPE_CHANED";
    LogType["SUBSCRIPTION_RENEWED"] = "SUBSCRIPTION_RENEWED";
    LogType["SUBSCRIPTION_PAYMENT"] = "SUBSCRIPTION_PAYMENT";
    LogType["SUBSCRIPTION_EXTRAS_ADDED"] = "SUBSCRIPTION_EXTRAS_ADDED";
    LogType["SUBSCRIPTION_EXTRAS_REMOVED"] = "SUBSCRIPTION_EXTRAS_REMOVED";
    LogType["GIFTED_SUBSCRIPTION_REDEEMED"] = "GIFTED_SUBSCRIPTION_REDEEMED";
    LogType["CASHBACK_CREDIT_ADDED"] = "CASHBACK_CREDIT_ADDED";
})(LogType || (LogType = {}));
export var Currency;
(function (Currency) {
    Currency["BHD"] = "BHD";
    Currency["SAR"] = "SAR";
    Currency["AED"] = "AED";
    Currency["KWD"] = "KWD";
    Currency["QAR"] = "QAR";
    Currency["OMR"] = "OMR";
})(Currency || (Currency = {}));
export var DeliveryTime;
(function (DeliveryTime) {
    DeliveryTime["morning"] = "morning";
    DeliveryTime["evening"] = "evening";
})(DeliveryTime || (DeliveryTime = {}));
export var AddressType;
(function (AddressType) {
    AddressType["home"] = "home";
    AddressType["office"] = "office";
})(AddressType || (AddressType = {}));
export var Period;
(function (Period) {
    Period["week"] = "week";
    Period["month"] = "month";
})(Period || (Period = {}));
export var RequestError;
(function (RequestError) {
    RequestError["OUT_OF_CAPACITY"] = "OUT_OF_CAPACITY";
    RequestError["PAYMENT_DECLINED"] = "PAYMENT_DECLINED";
    RequestError["EXPIRED_CARD"] = "EXPIRED_CARD";
    RequestError["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
})(RequestError || (RequestError = {}));
export var WaitingListAction;
(function (WaitingListAction) {
    WaitingListAction["CREATE_SUBSCRIPTION"] = "CREATE_SUBSCRIPTION";
    WaitingListAction["RESUME_SUBSCRIPTION"] = "RESUME_SUBSCRIPTION";
    WaitingListAction["CHANGE_COUNTRY"] = "CHANGE_COUNTRY";
})(WaitingListAction || (WaitingListAction = {}));
export var WaitingListType;
(function (WaitingListType) {
    WaitingListType["PRE_LAUNCH"] = "PRE_LAUNCH";
    WaitingListType["SOFT_LAUNCH"] = "SOFT_LAUNCH";
    WaitingListType["SUPPLY_CAP"] = "SUPPLY_CAP";
})(WaitingListType || (WaitingListType = {}));
export var CountryPhoneCode;
(function (CountryPhoneCode) {
    CountryPhoneCode["AE"] = "+971";
    CountryPhoneCode["BH"] = "+973";
    CountryPhoneCode["SA"] = "+966";
    CountryPhoneCode["KW"] = "+965";
    CountryPhoneCode["OM"] = "+968";
    CountryPhoneCode["QA"] = "+974";
    CountryPhoneCode["US"] = "+1";
})(CountryPhoneCode || (CountryPhoneCode = {}));
export var Country;
(function (Country) {
    Country["AE"] = "AE";
    Country["BH"] = "BH";
    Country["SA"] = "SA";
    Country["KW"] = "KW";
    Country["OM"] = "OM";
    Country["QA"] = "QA";
    Country["US"] = "US";
})(Country || (Country = {}));
export var IngredientCategory;
(function (IngredientCategory) {
    IngredientCategory["fish"] = "fish";
    IngredientCategory["beef"] = "beef";
    IngredientCategory["shellfish"] = "shellfish";
    IngredientCategory["chicken"] = "chicken";
    IngredientCategory["turkey"] = "turkey";
    IngredientCategory["spicyMeals"] = "spicyMeals";
    IngredientCategory["treeNuts"] = "treeNuts";
    IngredientCategory["dairy"] = "dairy";
    IngredientCategory["eggs"] = "eggs";
    IngredientCategory["soy"] = "soy";
    IngredientCategory["gluten"] = "gluten";
    IngredientCategory["beans"] = "beans";
    IngredientCategory["sesame"] = "sesame";
    IngredientCategory["peanut"] = "peanut";
    IngredientCategory["psylliumHusk"] = "psylliumHusk";
    IngredientCategory["other"] = "other";
})(IngredientCategory || (IngredientCategory = {}));
export var CouponType;
(function (CouponType) {
    CouponType["FIXED"] = "FIXED";
    CouponType["PERCENTAGE"] = "PERCENTAGE";
})(CouponType || (CouponType = {}));
export var FoodComponentType;
(function (FoodComponentType) {
    FoodComponentType["base"] = "base";
    FoodComponentType["protein"] = "protein";
    FoodComponentType["side"] = "side";
    FoodComponentType["topping"] = "topping";
    FoodComponentType["sauce"] = "sauce";
})(FoodComponentType || (FoodComponentType = {}));
export var FoodComponentIngredientAction;
(function (FoodComponentIngredientAction) {
    FoodComponentIngredientAction["ALLUMETTE"] = "Allumette 1/16\" X 1/16\" X 1/16\"";
    FoodComponentIngredientAction["BATON_STICKS"] = "Baton Sticks";
    FoodComponentIngredientAction["BRUNOISE"] = "Brunoise 1/16\" X 1/16\" X 1/16\"";
    FoodComponentIngredientAction["CHOPPED"] = "Chopped";
    FoodComponentIngredientAction["CONCASSE"] = "Concasse, Roughly Chopped";
    FoodComponentIngredientAction["DESEEDED"] = "Deseeded";
    FoodComponentIngredientAction["GRATED"] = "Grated";
    FoodComponentIngredientAction["JUICED"] = "Juiced";
    FoodComponentIngredientAction["JULIENNE"] = "Julienne 1/8\" X 1/4\" X 2\"";
    FoodComponentIngredientAction["LARGE_DICE"] = "Large Dice 3/4\" X 3/4\" X 3/4\"";
    FoodComponentIngredientAction["MEDIUM_DICE"] = "Medium Dice 1/2\" X 1/2\" X 1/2\"";
    FoodComponentIngredientAction["MINCED"] = "Minced, Chopped into fine pieces";
    FoodComponentIngredientAction["PEELED"] = "Peeled";
    FoodComponentIngredientAction["SHERD"] = "Sherd, Cut into thin strips";
    FoodComponentIngredientAction["SHREDDED"] = "Shredded";
    FoodComponentIngredientAction["SLICED"] = "Sliced";
    FoodComponentIngredientAction["SMALL_DICE"] = "Small Dice 1/4\" X 1/4\" X 1/4\"";
    FoodComponentIngredientAction["SPIRALIZED"] = "Spiralized";
    FoodComponentIngredientAction["WEDGED"] = "Wedged";
})(FoodComponentIngredientAction || (FoodComponentIngredientAction = {}));
export var InvitationCodeType;
(function (InvitationCodeType) {
    InvitationCodeType["HEALTHY_FOOD_LOVER"] = "HEALTHY_FOOD_LOVER";
    InvitationCodeType["TOO_BUSY"] = "TOO_BUSY";
    InvitationCodeType["NOT_SURE"] = "NOT_SURE";
    InvitationCodeType["FITNESS_FREAK"] = "FITNESS_FREAK";
    InvitationCodeType["LOSING_WEIGHT"] = "LOOSING_WEIGHT";
})(InvitationCodeType || (InvitationCodeType = {}));
export var UserAction;
(function (UserAction) {
    UserAction["CREATE_SUBSCRIPTION"] = "CREATE_SUBSCRIPTION";
    UserAction["ADD_SUBSCRIPTION_ADDONS"] = "ADD_SUBSCRIPTION_ADDONS";
    UserAction["ADD_DELIVERY_ADDONS"] = "ADD_DELIVERY_ADDONS";
    UserAction["REPLACE_FOOD"] = "REPLACE_FOOD";
    UserAction["RESUME_SUBSCRIPTION"] = "RESUME_SUBSCRIPTION";
    UserAction["PAY_PENDING_AMOUNT"] = "PAY_PENDING_AMOUNT";
    UserAction["RENEW_SUBSCRIPTION"] = "RENEW_SUBSCRIPTION";
    UserAction["PURCHASE_CUSTOM_FOOD"] = "PURCHASE_CUSTOM_FOOD";
    UserAction["PAY_NON_CONFIRMED_SUBSCRIPTION"] = "PAY_NON_CONFIRMED_SUBSCRIPTION";
    UserAction["ADD_FOOD"] = "ADD_FOOD";
    UserAction["DONATE_RAMADAN_MEAL"] = "DONATE_RAMADAN_MEAL";
    UserAction["PURCHASE_ADDONS_FOR_DELIVERY"] = "PURCHASE_ADDONS_FOR_DELIVERY";
})(UserAction || (UserAction = {}));
export var HealthTracker;
(function (HealthTracker) {
    HealthTracker["GOOGLE_FIT"] = "GOOGLE_FIT";
    HealthTracker["HEALTH_KIT"] = "HEALTH_KIT";
    HealthTracker["MANUAL"] = "MANUAL";
})(HealthTracker || (HealthTracker = {}));
export var HealthTrackerActivity;
(function (HealthTrackerActivity) {
    HealthTrackerActivity["AEROBICS"] = "AEROBICS";
    HealthTrackerActivity["AMERICAN_FOOTBALL"] = "AMERICAN_FOOTBALL";
    HealthTrackerActivity["ARCHERY"] = "ARCHERY";
    HealthTrackerActivity["AUSTRALIAN_FOOTBALL"] = "AUSTRALIAN_FOOTBALL";
    HealthTrackerActivity["BACK_COUNTRY_SKIING"] = "BACK_COUNTRY_SKIING";
    HealthTrackerActivity["BADMINTON"] = "BADMINTON";
    HealthTrackerActivity["BASEBALL"] = "BASEBALL";
    HealthTrackerActivity["BASKETBALL"] = "BASKETBALL";
    HealthTrackerActivity["BIATHLON"] = "BIATHLON";
    HealthTrackerActivity["BIKING"] = "BIKING";
    HealthTrackerActivity["BOWLING"] = "BOWLING";
    HealthTrackerActivity["BOXING"] = "BOXING";
    HealthTrackerActivity["BARRE"] = "BARRE";
    HealthTrackerActivity["CORE_TRAINING"] = "CORE_TRAINING";
    HealthTrackerActivity["CALISTHENICS"] = "CALISTHENICS";
    HealthTrackerActivity["CIRCUIT_TRAINING"] = "CIRCUIT_TRAINING";
    HealthTrackerActivity["CLIMBING"] = "CLIMBING";
    HealthTrackerActivity["CRICKET"] = "CRICKET";
    HealthTrackerActivity["CROSSFIT"] = "CROSSFIT";
    HealthTrackerActivity["CROSS_TRAINING"] = "CROSS_TRAINING";
    HealthTrackerActivity["CROSS_SKATING"] = "CROSS_SKATING";
    HealthTrackerActivity["CROSS_COUNTRY_SKIING"] = "CROSS_COUNTRY_SKIING";
    HealthTrackerActivity["CURLING"] = "CURLING";
    HealthTrackerActivity["CYCLING"] = "CYCLING";
    HealthTrackerActivity["DANCE"] = "DANCE";
    HealthTrackerActivity["DIVING"] = "DIVING";
    HealthTrackerActivity["DOWNHILL_SKIING"] = "DOWNHILL_SKIING";
    HealthTrackerActivity["ELLIPTICAL"] = "ELLIPTICAL";
    HealthTrackerActivity["ELEVATOR"] = "ELEVATOR";
    HealthTrackerActivity["ESCALATOR"] = "ESCALATOR";
    HealthTrackerActivity["ERGOMETER"] = "ERGOMETER";
    HealthTrackerActivity["EQUESTRIAN_SPORTS"] = "EQUESTRIAN_SPORTS";
    HealthTrackerActivity["FENCING"] = "FENCING";
    HealthTrackerActivity["FISHING"] = "FISHING";
    HealthTrackerActivity["FRISBEE"] = "FRISBEE";
    HealthTrackerActivity["FLEXIBILITY"] = "FLEXIBILITY";
    HealthTrackerActivity["FUNCTIONAL_STRENGTH_TRANING"] = "FUNCTIONAL_STRENGTH_TRANING";
    HealthTrackerActivity["FOOTBALL"] = "FOOTBALL";
    HealthTrackerActivity["GOLF"] = "GOLF";
    HealthTrackerActivity["GARDENING"] = "GARDENING";
    HealthTrackerActivity["GUIDED_BREATHING"] = "GUIDED_BREATHING";
    HealthTrackerActivity["GYMNASTICS"] = "GYMNASTICS";
    HealthTrackerActivity["HAND_CYCLING"] = "HAND_CYCLING";
    HealthTrackerActivity["HANDBALL"] = "HANDBALL";
    HealthTrackerActivity["HAND_BIKING"] = "HAND_BIKING";
    HealthTrackerActivity["HIKING"] = "HIKING";
    HealthTrackerActivity["HIIT"] = "HIIT";
    HealthTrackerActivity["HIGH_INTENSITY_INTERVAL_TRAINING"] = "HIGH_INTENSITY_INTERVAL_TRAINING";
    HealthTrackerActivity["HOCKEY"] = "HOCKEY";
    HealthTrackerActivity["HORSEBACK_RIDING"] = "HORSEBACK_RIDING";
    HealthTrackerActivity["HOUSEWORK"] = "HOUSEWORK";
    HealthTrackerActivity["HUNTING"] = "HUNTING";
    HealthTrackerActivity["ICE_SKATING"] = "ICE_SKATING";
    HealthTrackerActivity["INDOOR_SKATING"] = "INDOOR_SKATING";
    HealthTrackerActivity["IN_VECHICLE"] = "IN_VECHICLE";
    HealthTrackerActivity["INLINE_SKATING_ROLLERBLADING"] = "INLINE_SKATING_ROLLERBLADING";
    HealthTrackerActivity["INTERVAL_TRAINING"] = "INTERVAL_TRAINING";
    HealthTrackerActivity["JUMP_ROPE"] = "JUMP_ROPE";
    HealthTrackerActivity["JOGGING"] = "JOGGING";
    HealthTrackerActivity["KAYAKING"] = "KAYAKING";
    HealthTrackerActivity["KETTLEBELL_TRAINING"] = "KETTLEBELL_TRAINING";
    HealthTrackerActivity["KICKBOXING"] = "KICKBOXING";
    HealthTrackerActivity["KITESURFING"] = "KITESURFING";
    HealthTrackerActivity["KITE_SKIING"] = "KITE_SKIING";
    HealthTrackerActivity["LACROSSE"] = "LACROSSE";
    HealthTrackerActivity["MARTIAL_ARTS"] = "MARTIAL_ARTS";
    HealthTrackerActivity["MEDITATION"] = "MEDITATION";
    HealthTrackerActivity["MOUNTAIN_BIKING"] = "MOUNTAIN_BIKING";
    HealthTrackerActivity["MIND_AND_BODY"] = "MIND_AND_BODY";
    HealthTrackerActivity["MIXED_CARDIO"] = "MIXED_CARDIO";
    HealthTrackerActivity["MIXED_MARTIAL_ARTS"] = "MIXED_MARTIAL_ARTS";
    HealthTrackerActivity["OTHER"] = "OTHER";
    HealthTrackerActivity["PADDLE_SPORTS"] = "PADDLE_SPORTS";
    HealthTrackerActivity["PARAGLIDING"] = "PARAGLIDING";
    HealthTrackerActivity["PLAY"] = "PLAY";
    HealthTrackerActivity["PILATES"] = "PILATES";
    HealthTrackerActivity["PREPARATION_AND_RECOVERY"] = "PREPARATION_AND_RECOVERY";
    HealthTrackerActivity["POLO"] = "POLO";
    HealthTrackerActivity["P90X_EXERCISES"] = "P90X_EXERCISES";
    HealthTrackerActivity["RACQUETBALL"] = "RACQUETBALL";
    HealthTrackerActivity["ROWING"] = "ROWING";
    HealthTrackerActivity["ROWING_MACHINE"] = "ROWING_MACHINE";
    HealthTrackerActivity["ROAD_BIKING"] = "ROAD_BIKING";
    HealthTrackerActivity["ROLLER_SKIING"] = "ROLLER_SKIING";
    HealthTrackerActivity["RROCK_CLIMBING"] = "ROCK_CLIMBING";
    HealthTrackerActivity["RUGBY"] = "RUGBY";
    HealthTrackerActivity["RUNNING"] = "RUNNING";
    HealthTrackerActivity["RUNNING_ON_SAND"] = "RUNNING_ON_SAND";
    HealthTrackerActivity["RUNNING_ON_TREADMILL"] = "RUNNING_ON_TREADMILL";
    HealthTrackerActivity["SAILING"] = "SAILING";
    HealthTrackerActivity["SCUBA_DIVING"] = "SCUBA_DIVING";
    HealthTrackerActivity["SKATING"] = "SKATING";
    HealthTrackerActivity["SKATING_SPORTS"] = "SKATING_SPORTS";
    HealthTrackerActivity["SKATEBOARDING"] = "SKATEBOARDING";
    HealthTrackerActivity["SLEDDING"] = "SLEDDING";
    HealthTrackerActivity["SNOW_SPORTS"] = "SNOW_SPORTS";
    HealthTrackerActivity["SNOW_MOBILE"] = "SNOW_MOBILE";
    HealthTrackerActivity["SNOW_SHOEING"] = "SNOW_SHOEING";
    HealthTrackerActivity["SOCCER"] = "SOCCER";
    HealthTrackerActivity["SOFTBALL"] = "SOFTBALL";
    HealthTrackerActivity["SPINNING"] = "SPINNING";
    HealthTrackerActivity["SQUASH"] = "SQUASH";
    HealthTrackerActivity["STAND_UP_PADDLE_BOARDING"] = "STAND_UP_PADDLE_BOARDING";
    HealthTrackerActivity["STAIR_CLIMBING"] = "STAIR_CLIMBING";
    HealthTrackerActivity["STAIR_CLIMBING_MACHINE"] = "STAIR_CLIMBING_MACHINE";
    HealthTrackerActivity["STATIONARY_BIKING"] = "STATIONARY_BIKING";
    HealthTrackerActivity["STRENGTH_TRAINING"] = "STRENGTH_TRAINING";
    HealthTrackerActivity["STILL"] = "STILL";
    HealthTrackerActivity["SNOWBOARDING"] = "SNOWBOARDING";
    HealthTrackerActivity["STAIRS"] = "STAIRS";
    HealthTrackerActivity["STEP_TRAINING"] = "STEP_TRAINING";
    HealthTrackerActivity["SURFING"] = "SURFING";
    HealthTrackerActivity["SURFING_SPORTS"] = "SURFING_SPORTS";
    HealthTrackerActivity["SWIMMING"] = "SWIMMING";
    HealthTrackerActivity["SWIMMING_OPEN_WATER"] = "SWIMMING_OPEN_WATER";
    HealthTrackerActivity["SWIMMING_POOL"] = "SWIMMING_POOL";
    HealthTrackerActivity["TABLE_TENNIS"] = "TABLE_TENNIS";
    HealthTrackerActivity["TENNIS"] = "TENNIS";
    HealthTrackerActivity["TEAM_SPORTS"] = "TEAM_SPORTS";
    HealthTrackerActivity["TILTING"] = "TILTING";
    HealthTrackerActivity["TRACK_AND_FIELD"] = "TRACK_AND_FIELD";
    HealthTrackerActivity["TRADITIONAL_STRENGTH_TRAINING"] = "TRADITIONAL_STRENGTH_TRAINING";
    HealthTrackerActivity["TAI_CHI"] = "TAI_CHI";
    HealthTrackerActivity["UTILITY_BIKING"] = "UTILITY_BIKING";
    HealthTrackerActivity["UNKNOWN"] = "UNKNOWN";
    HealthTrackerActivity["VOLLEYBALL"] = "VOLLEYBALL";
    HealthTrackerActivity["VOLLEYBALL_BEACH"] = "VOLLEYBALL_BEACH";
    HealthTrackerActivity["WAKEBOARDING"] = "WAKEBOARDING";
    HealthTrackerActivity["WALKING"] = "WALKING";
    HealthTrackerActivity["WALKING_STROLLER"] = "WALKING_STROLLER";
    HealthTrackerActivity["WALKING_ON_TREADMILL"] = "WALKING_ON_TREADMILL";
    HealthTrackerActivity["WATER_FITNESS"] = "WATER_FITNESS";
    HealthTrackerActivity["WATERPOLO"] = "WATERPOLO";
    HealthTrackerActivity["WATER_SPORTS"] = "WATER_SPORTS";
    HealthTrackerActivity["WRESTLING"] = "WRESLING";
    HealthTrackerActivity["WEIGHTLIFTING"] = "WEIGHTLIFTING";
    HealthTrackerActivity["WHEEL_CHAIR_WALK_PACE"] = "WHEEL_CHAIR_WALK_PACE";
    HealthTrackerActivity["WHEEL_CHAIR_RUN_PACE"] = "WHEEL_CHAIR_RUN_PACE";
    HealthTrackerActivity["WINDSURFING"] = "WINDSURFING";
    HealthTrackerActivity["YOGA"] = "YOGA";
    HealthTrackerActivity["ZUMBA"] = "ZUMBA";
})(HealthTrackerActivity || (HealthTrackerActivity = {}));
export var Brand;
(function (Brand) {
    Brand["CALO"] = "CALO";
    Brand["MEALO"] = "MEALO";
})(Brand || (Brand = {}));
export var MenuTagValue;
(function (MenuTagValue) {
    MenuTagValue["NEW"] = "NEW";
    MenuTagValue["DAIRY_FREE"] = "DAIRY_FREE";
    MenuTagValue["UPGRADED"] = "UPGRADED";
    MenuTagValue["TOP_RATED"] = "TOP_RATED";
    MenuTagValue["SEASONAL"] = "SEASONAL";
})(MenuTagValue || (MenuTagValue = {}));
export var WalletReason;
(function (WalletReason) {
    WalletReason["CALO_TEAM_PERKS"] = "CALO_TEAM_PERKS";
    WalletReason["CASH_OR_BENEFIT_PAYMENT"] = "CASH_OR_BENEFIT_PAYMENT";
    WalletReason["COMPENSATION"] = "COMPENSATION";
    WalletReason["MANUAL_DISCOUNT"] = "MANUAL_DISCOUNT";
    WalletReason["CX_GIFT"] = "CX_GIFT";
    WalletReason["MARKETING_GIFT_AND_EXPERIMENTS"] = "MARKETING_GIFT_AND_EXPERIMENTS";
    WalletReason["CALO_BUSINESS"] = "CALO_BUSINESS";
    WalletReason["TRANSFERRED_CREDITS"] = "TRANSFERRED_CREDITS";
    WalletReason["CUSTOMERS_INFLUENCERS"] = "CUSTOMERS_INFLUENCERS";
    WalletReason["CUSTOMERS_CALO_EXPERIMENTS"] = "CUSTOMERS_CALO_EXPERIMENTS";
    WalletReason["CUSTOMERS_FRIENDS_REFERRAL"] = "CUSTOMERS_FRIENDS_REFERRAL";
    WalletReason["COMPLEMENTARY_CARD"] = "COMPLEMENTARY_CARD";
    WalletReason["INVAILID_ENTRY"] = "INVAILID_ENTRY";
    WalletReason["DOUBLE_ENTRY"] = "DOUBLE_ENTRY";
    WalletReason["REFUNDED_MANUALLY"] = "REFUNDED_MANUALLY";
    WalletReason["FIXING_BALANCE"] = "FIXING_BALANCE";
    WalletReason["CREDIT_TRANSFER"] = "CREDIT_TRANSFER";
    WalletReason["REMOVING_GIFTS"] = "REMOVING_GIFTS";
    WalletReason["REMOVING_DISCOUNT_CODE_CREDITS"] = "REMOVING_DISCOUNT_CODE_CREDITS";
    WalletReason["CASHBACK_CARD"] = "CASHBACK_CARD";
    WalletReason["DELIVERY_DEDUCTION"] = "DELIVERY_DEDUCTION";
    WalletReason["OTHER"] = "OTHER";
})(WalletReason || (WalletReason = {}));
export var RefundReason;
(function (RefundReason) {
    RefundReason["ALLERGIC_CONDITIONS"] = "ALLERGIC_CONDITIONS";
    RefundReason["DOUBLE_CHARGE"] = "DOUBLE_CHARGE";
    RefundReason["BUG"] = "BUG";
    RefundReason["FOOD_POISONING"] = "FOOD_POISONING";
    RefundReason["FOREIGN_OBJECT"] = "FOREIGN_OBJECT";
    RefundReason["LEAVING_THE_COUNTRY"] = "LEAVING_THE_COUNTRY";
    RefundReason["MEDICAL_CONDITION"] = "MEDICAL_CONDITION";
    RefundReason["PARTIAL_REFUND"] = "PARTIAL_REFUND";
    RefundReason["PERSONAL_PREFERENCE"] = "PERSONAL_PREFERENCE";
    RefundReason["PERSONAL_REASONS"] = "PERSONAL_REASONS";
    RefundReason["QUALITY_OF_THE_MEALS"] = "QUALITY_OF_THE_MEALS";
    RefundReason["UNAVAILABLE_DIETARY_PLANS"] = "UNAVAILABLE_DIETARY_PLANS";
    RefundReason["UNINTENTIONAL_RENEWAL"] = "UNINTENTIONAL_RENEWAL";
    RefundReason["UNPLEASED_WITH_THE_DELIVERY"] = "UNPLEASED_WITH_THE_DELIVERY";
    RefundReason["UNABLE_TO_CONTROL_MACROS_OR_CALORIES"] = "UNABLE_TO_CONTROL_MACROS_OR_CALORIES";
    RefundReason["DISPATCH_ERROR"] = "DISPATCH_ERROR";
})(RefundReason || (RefundReason = {}));
export var PaymentError;
(function (PaymentError) {
    PaymentError["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    PaymentError["PAYMENT_REQUIRED"] = "PAYMENT_REQUIRED";
    PaymentError["PAYMENT_METHOD_NOT_SUPPORTED"] = "PAYMENT_METHOD_NOT_SUPPORTED";
    PaymentError["PAYMENT_DECLINED"] = "PAYMENT_DECLINED";
    PaymentError["EXPIRED_CARD"] = "EXPIRED_CARD";
    PaymentError["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    PaymentError["NON_3D_SECURE_TRANSACTIONS_NOT_ALLOWED"] = "NON_3D_SECURE_TRANSACTIONS_NOT_ALLOWED";
    PaymentError["PAYMENT_PROVIDER_INTERNAL_SERVER_ERROR"] = "PAYMENT_PROVIDER_INTERNAL_SERVER_ERROR";
    PaymentError["CARD_ISSUER_ISSUE"] = "CARD_ISSUER_ISSUE";
    PaymentError["CARD_DECLINED_BY_ISSUER"] = "CARD_DECLINED_BY_ISSUER";
    PaymentError["CARD_DECLINED_BY_PAYMENT_PROVIDER"] = "CARD_DECLINED_BY_PAYMENT_PROVIDER";
    PaymentError["TRANSACTION_TYPE_NOT_SUPPORTED"] = "TRANSACTION_TYPE_NOT_SUPPORTED";
    PaymentError["INCORRECT_SECURITY_CODE"] = "INCORRECT_SECURITY_CODE";
    PaymentError["INVALID_CARD_NUMBER"] = "INVALID_CARD_NUMBER";
    PaymentError["INVALID_EXPIRY_DATE"] = "INVALID_EXPIRY_DATE";
    PaymentError["INVALID_REQUIRED_PARAMETER"] = "INVALID_REQUIRED_PARAMETER";
    PaymentError["UNSPECIFIED_FAILURE"] = "UNSPECIFIED_FAILURE";
    PaymentError["DUPLICATE"] = "DUPLICATE";
    PaymentError["RESTRICTED"] = "RESTRICTED";
    PaymentError["RESTRICTED_RETRY_LIMIT_EXCEEDED"] = "RESTRICTED_RETRY_LIMIT_EXCEEDED";
    PaymentError["RESTRICTED_BY_CARD_ISSUER"] = "RESTRICTED_BY_CARD_ISSUER";
    PaymentError["RESTRICTED_BY_PAYMENT_PROVIDER"] = "RESTRICTED_BY_PAYMENT_PROVIDER";
})(PaymentError || (PaymentError = {}));
export var FoodActionType;
(function (FoodActionType) {
    FoodActionType["add"] = "add";
    FoodActionType["remove"] = "remove";
})(FoodActionType || (FoodActionType = {}));
export var HeatingInstruction;
(function (HeatingInstruction) {
    HeatingInstruction["HEATING_WITH_SAUCE"] = "HEATING_WITH_SAUCE";
    HeatingInstruction["HEATING_NO_SAUCE"] = "HEATING_NO_SAUCE";
    HeatingInstruction["COLD"] = "COLD";
    HeatingInstruction["HEATING_SANDWICH"] = "HEATING_SANDWICH";
    HeatingInstruction["HEATING_SNACK"] = "HEATING_SNACK";
    HeatingInstruction["NONE"] = "NONE";
})(HeatingInstruction || (HeatingInstruction = {}));
export var TransactionHistoryType;
(function (TransactionHistoryType) {
    TransactionHistoryType["CREDIT"] = "CREDIT";
    TransactionHistoryType["DEBIT"] = "DEBIT";
})(TransactionHistoryType || (TransactionHistoryType = {}));
export var TransactionHistorySource;
(function (TransactionHistorySource) {
    TransactionHistorySource["REFUND"] = "REFUND";
    TransactionHistorySource["PAYMENT"] = "PAYMENT";
    TransactionHistorySource["MANUAL_ADDITION"] = "MANUAL_ADDITION";
    TransactionHistorySource["MANUAL_DEDUCTION"] = "MANUAL_DEDUCTION";
})(TransactionHistorySource || (TransactionHistorySource = {}));
export var ActionSource;
(function (ActionSource) {
    ActionSource["WEB"] = "WEB";
    ActionSource["APP"] = "APP";
})(ActionSource || (ActionSource = {}));
